<template>
  <div class="rankingListRootBox" :style="{justifyContent: !isDialog?'center':'start'}">
    <div class="tabHeader" ref="tabHeader">
      <slot name="tabHeader" :data="headers"></slot>
    </div>
    <div class="rankingBox" v-loading="loading && !showMoreDialog">
      <div class="ranking">
        <div class="icon">{{ titles.column1Name }}</div>
        <div class="name">{{ titles.column2Name }}</div>
        <div class="time">{{ titles.column3Name }}</div>
      </div>
      <div class="ranking list" v-for="(item,index) in currentRankingList" :key="index">
        <div class="icon">
          <img v-if="index<5 && pageNum<=1"
               :src="require(`@/assets/icon/icon_ranking_${index<3?index+1:'other'}.png`)"/>
          <div class="num" v-if="index>=3 || pageNum>1" :style="(index>=5 || pageNum>1)?'transform: scale(1)':null">
            {{ (pageNum - 1) * 10 + (index + 1) }}
          </div>
        </div>
        <div class="name" :title="item.name">{{ item.name }}</div>
        <div class="time" :title="getDate(item.content)">{{ getDate(item.content) }}</div>
      </div>
      <div v-if="!rankingList.length" class="loading">
        <el-empty :image-size="80" style="margin-top: 50px;" :description="' '"></el-empty>
      </div>
      <div class="more" @click="showDialog"
           :style="{visibility: !showMoreDialog && !loading && !isDialog && total>endIndex?null:'hidden'}">查看更多
      </div>
    </div>

    <el-dialog
      title=""
      :visible.sync="showMoreDialog"
      width="40vw"
      destroy-on-close
      @close="close"
      :close-on-click-modal="false"
    >
      <div style="height: 50vh;width: 100%;display: flex;flex-direction: column;align-items: center">
        <m-ranking-list :ranking-list="rankingList" :end-index="10" :is-dialog="true"
                        :page-num="currentPage" :min-titles="minTitles" :is-date="isDate"></m-ranking-list>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          background
          layout="prev, pager, next"
          :total="total" style="margin-top: 10px">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "mRankingList",
  inject: ['secondsToDate'],
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    tag: {
      type: [String, Number],
      default: null
    },
    minTitles: {
      type: Object,
      default: () => ({})
    },
    rankingList: {
      type: Array,
      default: () => []
    },
    endIndex: {
      type: Number,
      default: 5
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    isDate: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    selectValue(val) {
      this.$emit('tabChange', val, this.tag)
    },
    rankingList: {
      handler(val) {
        if (!this.isDialog) {
          if (!this.currentRankingList || !this.currentRankingList.length || this.currentRankingList[0] !== val[0] && !this.showMoreDialog) {
            this.currentRankingList = val.slice(0, 5)
          }
        } else {
          this.currentRankingList = [...val]
        }
      },
      deep: true,
      immediate: true
    },
    minTitles: {
      handler(val) {
        Object.assign(this.titles, val)
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    getDate() {
      return function (content) {
        if (this.isDate && /^\d+$/.test(String(content))) {
          return this.secondsToDate(Number(content))
        }
        return content
      }
    }
  },
  data() {
    return {
      currentRankingList: [],
      showMoreDialog: false,
      currentPage: 1,
      selectValue: '0',
      titles: {
        column1Name: '排名',
        column2Name: '学员',
        column3Name: '学习时长',
      }
    }
  },
  mounted() {
    this.initFun()
  },
  methods: {
    initFun() {
      const childrenList = [...this.$refs.tabHeader.children]
      if (childrenList.length) {
        childrenList.forEach(children => {
          children.addEventListener('click', ev => {
            childrenList.forEach(children => children.classList.remove('tabSelected'))
            ev.target.classList.add('tabSelected')
          })
        })
        childrenList[0].classList.add('tabSelected')
      }
    },
    handleSizeChange(num) {
    },
    handleCurrentChange(num) {
      this.currentPage = num
      this.$emit('pageChange', num)
    },
    showDialog() {
      this.currentPage = 1
      this.showMoreDialog = true
      this.handleCurrentChange(1)
    },
    close() {

    }
  }
}
</script>

<style lang="scss" scoped>
.rankingListRootBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: calc(0.14 * var(--fontSize));
  white-space: nowrap;
  overflow-y: auto;

  & > div.tabHeader {
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    z-index: 9;
    gap: 12px;
    height: calc(0.35 * var(--fontSize));

    & > * {
      cursor: pointer;
      transition: 0.2s;
      height: calc(0.35 * var(--fontSize));
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: calc(0.235 * var(--fontSize));
    }

    & > .tabSelected {
      height: 100%;
      background: rgba(88, 159, 248, 1);
      border: 1px solid rgba(255, 255, 255, 1);
      box-shadow: -7px -7px 20px 0px rgba(255, 255, 255, 0.8), 7px 7px 20px 0px rgba(222, 221, 227, 1);
      display: inline-flex;
      color: white;
      align-items: center;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }

  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #808080;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .more:hover {
    color: #4fa2f3;
  }

  .rankingBox {
    display: grid;
    grid-template-rows: repeat(7, 1fr);
    align-items: center;
    justify-content: center;
    width: calc(3.05 * var(--fontSize));
    height: calc(2.81 * var(--fontSize));
    position: relative;

    .loading {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      grid-row: 3/span 4;
    }

    & > div.ranking {
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: rgba(0, 0, 0, .4);
      width: calc(3.55 * var(--fontSize));
      height: 35px;

      & > div {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
        padding: 0 2px;
        box-sizing: border-box;
      }

      .icon {
        flex: 1;
      }

      .name {
        flex: 1.5;
      }

      & > .icon {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 50px;
        height: 50px;

        .num {
          position: absolute;
          font-weight: 500;
          font-size: 12px;
          transform: scale(.6);
          margin-top: 4px;
        }

        img {
          width: calc(0.18 * var(--fontSize));
          height: calc(0.1838 * var(--fontSize));
        }
      }

      .time {
        flex: 2.5;
      }
    }

    //& > .ranking:last-child .icon .num {
    //  color: #8f8f8f;
    //}

    .list {
      color: #000000;
    }

    & > .ranking:not(:nth-child(1)):hover {
      background-color: #fafafa;

      & > .icon {
        animation: shake .6s infinite linear alternate;
      }
    }
  }

  @keyframes shake {
    from {
      transform: translateX(-5px) rotate(-15deg);
    }
    to {
      transform: translateX(5px) rotate(15deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/components/mRankingList.vue